import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ContentQuestionModel } from 'app/teacher/activities/models/content-question-model';

@Component({
  template: '',
  standalone: false
})

export abstract class BaseEnhancedReportComponent {
  private readonly bsModalRef = inject(BsModalRef);

  public question!: ContentQuestionModel;

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
